'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';

import { cn } from '@/lib/utils';

type Props = {
  href: never;
  children: ReactNode;
  active?: boolean;
  className?: string;
  target?: string;
};

export function NavbarItem({
  children,
  href,
  active,
  target,
  className,
}: Props) {
  const pathname = usePathname();

  return (
    <Link
      href={href}
      className={cn(
        'flex items-center justify-center text-base font-medium leading-[110%] px-4 py-2 rounded-md hover:bg-neutral-100 hover:text-black text-black transition duration-200',
        (active || pathname?.includes(href)) && 'bg-neutral-50 text-black',
        className
      )}
      target={target}
    >
      {children}
    </Link>
  );
}
